import { Box } from '@volue/wave-react';
import React from 'react';

const trimVersion = (version: string) => {
  return version.slice(0, 12);
};

export const ApplicationVersionLabel = (props: { version: string }) => {
  return (
    <Box css={{ textAlign: 'center' }}>
      {'version: '}
      {trimVersion(props.version)}
    </Box>
  );
};
